import React, { ReactNode } from "react";
import { Breadcrumbs, Flex, Text } from "@jsq/ds/core";
import {
  actionsSlot,
  subtitle,
  tabsRow,
  titleBlock,
  titleBlockWithTabs,
} from "./styles_vanilla.css";
import { toHeaderContent } from "./utils";
import type { DashBoardHeaderConfig } from "./types";

export const DashBoardHeader = ({
  config,
  tabs,
  actions,
}: {
  config: DashBoardHeaderConfig;
  tabs?: ReactNode;
  actions?: ReactNode;
}) => {
  const content = toHeaderContent(config);

  const breadcrumbs = content.breadcrumbs.map((item) => ({
    name: item.label,
    onClick: item.onClick,
  }));

  const hasTabsRow = Boolean(tabs) || Boolean(actions);

  return (
    <Flex flexDirection="column">
      <div className={hasTabsRow ? titleBlockWithTabs : titleBlock}>
        {breadcrumbs.length > 0 && <Breadcrumbs breadcrumbs={breadcrumbs} />}
        <Text variant="h1">{content.title}</Text>
        <Text variant="regular-lg" className={subtitle}>
          {content.subtitle}
        </Text>
      </div>
      {hasTabsRow && (
        <div className={tabsRow}>
          <div>{tabs}</div>
          {actions && <div className={actionsSlot}>{actions}</div>}
        </div>
      )}
    </Flex>
  );
};
